module.exports = __webpack_public_path__ + "img/arrow-down.7b55a046.svg";